import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=4597feb4&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=js&"
export * from "./assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597feb4",
  null
  
)

export default component.exports